module.exports = __webpack_public_path__ + "img/vpn-proxy-master.4bada3d.png";